import { useState } from 'react'

import { Avatar } from '@/components/ui/Avatar'
import { Button } from '@/components/ui/Button'
import { LogoutIcon, UserPlusIcon } from '@/components/ui/icons'
import { usePageMeta } from '@/app/router/routeMeta'
import { useLogout } from '@/features/auth/hooks/useLogout'
import { useAuth } from '@/features/auth/authContext'
import { LocationSwitcher } from '@/components/layout/PageHeader/LocationSwitcher'
import { InviteUserModal } from '@/features/invitations/components/InviteUserModal'
import { useCanInviteUsers } from '@/features/invitations/hooks/useCanInviteUsers'
import { useTermLabel } from '@/hooks/useTerm'

import styles from './PageHeader.module.css'

export function PageHeader() {
  const meta = usePageMeta()
  const { user, role } = useAuth()
  const logout = useLogout()
  const canInvite = useCanInviteUsers()
  const [inviteOpen, setInviteOpen] = useState(false)
  const termLabel = useTermLabel()

  return (
    <div className={styles.header}>
      <div className={styles.titles}>
        <h1 className={styles.title}>{meta ? termLabel(meta.title) : ''}</h1>
        {meta?.subtitle && <p className={styles.subtitle}>{meta.subtitle}</p>}
      </div>

      <div className={styles.actions}>
        <LocationSwitcher />

        {canInvite && (
          <Button
            size="sm"
            variant="secondary"
            leadingIcon={<UserPlusIcon />}
            onClick={() => setInviteOpen(true)}
          >
            Einladen
          </Button>
        )}

        {user && (
          <button
            type="button"
            className={styles.userChip}
            title="Abmelden"
            aria-label={`Abmelden (${user.displayName})`}
            disabled={logout.isPending}
            onClick={() => logout.mutate()}
          >
            <Avatar name={user.displayName} />
            <span className={styles.userMeta}>
              <strong>{user.displayName}</strong>
              <span>{role?.label}</span>
            </span>
            <LogoutIcon className={styles.logoutIcon} />
          </button>
        )}
      </div>

      {canInvite && <InviteUserModal open={inviteOpen} onClose={() => setInviteOpen(false)} />}
    </div>
  )
}
